<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="status == 'FINISHED' || status == 'CANCEL'"
                >
                  <v-text-field
                    slot="activator"
                    label="Issue Date"
                    type="text"
                    prepend-icon="event"
                    v-model="issueDate"
                    readonly
                    :rules="rules.issueDateRules"
                  ></v-text-field>
                  <v-date-picker v-model="issueDate" :rules="rules.issueDateRules"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="purchaseOrder.id">
                <v-text-field
                  name="issueNo"
                  label="Issue No."
                  v-model="purchaseOrder.issueNo"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="purchaseOrder.supplierId"
                  :items="supplierList"
                  color="blue-grey lighten-2"
                  label="Choose Supplier..."
                  item-text="companyName"
                  menu-props="auto"
                  item-value="id"
                  :readonly="!!purchaseOrder.id"
                  :rules="rules.supplierRules"
                  @change="getCurrencyBySupplierId(purchaseOrder.supplierId)"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="purchaseOrder.currencyId"
                  :items="currencyList"
                  color="blue-grey lighten-2"
                  label="Choose Currency..."
                  item-text="code"
                  hint="Please Choose Supplier First."
                  menu-props="auto"
                  item-value="id"
                  @change="changeCurrencyCode()"
                  :rules="rules.currencyRules"
                  :readonly="!!purchaseOrder.id"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  v-model="purchaseOrder.warehouseId"
                  :items="warehouseList"
                  color="blue-grey lighten-2"
                  label="Choose Warehouse..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :readonly="status == 'FINISHED' || status == 'CANCEL' || user.role.roleName == 'WAREHOUSE_MANAGER'"
                  :rules="rules.warehouseRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-autocomplete
                  :readonly="status == 'FINISHED' || status == 'CANCEL'"
                  v-model="purchaseOrder.status"
                  :items="statusList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Status..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :rules="rules.statusRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="purchaseOrder.description"
                  type="text"
                  :readonly="status == 'FINISHED' || status == 'CANCEL'"
                  :rules="rules.descriptionRuless"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="purchaseOrder.id">
                <v-text-field label="Created Date" v-model="createdDate" type="text" readonly></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="purchaseOrder.id">
                <v-text-field
                  label="Created By"
                  v-model="purchaseOrder.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="purchaseOrder.id">
                <v-text-field label="Updated Date" v-model="updatedDate" type="text" readonly></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="purchaseOrder.id">
                <v-text-field
                  label="Updated By"
                  v-model="purchaseOrder.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn
                    color="success"
                    @click="addPurchaseOrderItem()"
                    :disabled="status == 'FINISHED' || status == 'CANCEL'"
                  >
                    Add Purchase Order Item
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout row wrap class="light--text">
                  <v-flex xs2>Code</v-flex>
                  <v-flex xs2>Product</v-flex>
                  <v-flex xs1>Unit</v-flex>
                  <v-flex xs1>Qty</v-flex>
                  <v-flex xs1>Unit Cost</v-flex>
                  <v-flex xs1>Selling Price</v-flex>
                  <v-flex xs2>Remark</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(item, index) in purchaseOrder.purchaseOrderItems"
                  :key="index"
                >
                  <v-flex xs2>
                    <v-text-field
                      v-if="status == 'FINISHED' || status == 'CANCEL'"
                      placeholder="Select the code"
                      v-model="item.productCode"
                      readonly
                      :rules="rules.codeRules"
                    ></v-text-field>
                    <v-text-field
                      v-else
                      placeholder="Select the code"
                      v-model="item.productCode"
                      @click="showProducts(), selectedIndex = index"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="item.productName"
                      :loading="showAutocompleteLoading"
                      label="Product"
                      :readonly="true"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-autocomplete
                      v-model="item.factorUnitName"
                      :loading="showAutocompleteLoading"
                      :hide-no-data="true"
                      :items="item.productUnits"
                      color="blue-grey lighten-2"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      menu-props="auto"
                      label="Select"
                      :readonly="status == 'FINISHED' || status == 'CANCEL'"
                      @change="option => initPrice(option,index)"
                      :rules="rules.unitRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="item.qty"
                      type="number"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :rules="rules.qtyRules"
                      :readonly="status == 'FINISHED' || status == 'CANCEL'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="item.unitCost"
                      type="number"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :rules="rules.unitCostRules"
                      :readonly="status == 'FINISHED' || status == 'CANCEL'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-text-field
                      v-model="item.sellingPrice"
                      type="number"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :readonly="status == 'FINISHED' || status == 'CANCEL'"
                      :rules="rules.sellingPriceRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="item.remark"
                      type="text"
                      :rules="rules.remarkRules"
                      :readonly="status == 'FINISHED' || status == 'CANCEL'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      icon
                      @click="removePurchaseOrderItem(index, item.id)"
                      :disabled=" status == 'FINISHED' || status ==  'CANCEL' || index == 0"
                    >
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    type="submit"
                    :disabled="btnDisabled || saveLoading"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Product Code"
                type="text"
                class="mr-1"
                v-model="queryParams.productCode"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Product Name"
                type="text"
                class="mr-1"
                v-model="queryParams.productName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand Name"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category Name"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group Name"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              :headers="headers"
              :items="productList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td
                  @click="setProduct(props.item.code, selectedIndex), showProductListDialog = !showProductListDialog"
                >
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.brand.name }}</td>
                <td>{{ props.item.category.name }}</td>
                <td v-if="props.item.productGroup">{{ props.item.productGroup.name }}</td>
                <td v-else></td>
                <td>{{ props.item.description }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { warehouseService } from "../../services/warehouse-service";
import { supplierProductService } from "../../services/supplier-product-service";
import { commonService } from "../../services/common-service";
import { purchaseOrderService } from "../../services/purchase-order-service";
import { supplierService } from "../../services/supplier-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { PurchaseOrder, PurchaseOrderItem } from "../../models/model";
import { PurchaseOrderFormRules } from "../../helpers/validation-rules";

export default {
  name: "PurchaseOrderDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Purchase Order",
        disabled: false,
        to: "purchase-order"
      },
      {
        text: "Purchase Order Detail",
        disabled: true
      }
    ],
    status: "DRAFT",
    issueDate: "",
    purchaseOrder: new PurchaseOrder(),
    oldpurchaseOrder: new PurchaseOrder(),
    purchaseOrderItem: new PurchaseOrderItem(),
    rules: new PurchaseOrderFormRules(),
    responseError: "",
    showAutocompleteLoading: false,
    saveLoading: false,
    warehouseList: [],
    productUnitList: [],
    currencyList: [],
    productList: [],
    supplierList: [],
    btnDisabled: false,
    statusList: [
      { label: "DRAFT", value: "DRAFT" },
      { label: "QUOTATION", value: "QUOTATION" },
      { label: "FINISHED", value: "FINISHED" },
      { label: "CANCEL", value: "CANCEL" }
    ],
    showProductListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" }
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0
    },
    totalRows: 0,
    updatedDate: "",
    createdDate: "",
    queryParams: {
      supplierId: "",
      productName: "",
      productCode: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      currencyId: "",
    },
    search: null,
    code: "",
    showListLoading: false,
    selectedIndex: 0
  }),

  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true
    }
  },

  created() {
    this.getWarehouseList();
    this.addPurchaseOrderItem();
    this.getAllSupplier();
    const id = this.$route.params.id;
    if (id == "new") {
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
      if (this.user.roleName == "WAREHOUSE_MANAGER") {
        this.purchaseOrder.warehouseId = this.user.warehouseId;
      }
    } else {
      this.getPurchaseOrderDetail(id);
      this.getProductList();
    }
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },

    getCurrencyBySupplierIdForUpdate(supplierId) {
      this.currencyList = [];
      supplierService
        .getCurrencyBySupplierId(supplierId)
        .then(res => {
          this.currencyList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getCurrencyBySupplierId(supplierId) {
      this.productList = [];
      this.purchaseOrder.purchaseOrderItems = [];
      this.addPurchaseOrderItem();
      this.queryParams.supplierId = supplierId;
      supplierService
        .getCurrencyBySupplierId(supplierId)
        .then(res => {
          this.currencyList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getAllSupplier() {
      supplierService
        .getAllSupplier()
        .then(res => {
          this.supplierList = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getWarehouseList() {
      warehouseService
        .getAllWarehouse("ACTIVE")
        .then(res => {
          let tempList = res.data;
          for (let temp of tempList) {
            this.warehouseList.push(temp);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    goBack() {
      this.$router.push("/purchase-order");
    },

    addPurchaseOrderItem() {
      // deep copy
      purchaseOrderItem = new PurchaseOrderItem();
      let purchaseOrderItem = JSON.parse(
        JSON.stringify(this.purchaseOrderItem)
      );

      this.purchaseOrder.purchaseOrderItems.push(purchaseOrderItem);
    },
    changeCurrencyCode(){
        this.purchaseOrder.purchaseOrderItems = [];
    },
    removePurchaseOrderItem(index, purchaseOrderItemId) {
      if (purchaseOrderItemId) {
        // add delete purchaseOrderItem id
        if (!this.purchaseOrder.deletePurchaseOrderItemIds) {
          this.purchaseOrder.deletePurchaseOrderItemIds = [];
        }
        this.purchaseOrder.deletePurchaseOrderItemIds.push(purchaseOrderItemId);
      }
      this.$delete(this.purchaseOrder.purchaseOrderItems, index);
    },

    getPurchaseOrderDetail(id) {
      purchaseOrderService
        .getPurchaseOrderDetail(id)
        .then(res => {
          this.purchaseOrder = res.data;
          this.queryParams.supplierId = this.purchaseOrder.supplierId;
          this.getCurrencyBySupplierIdForUpdate(this.purchaseOrder.supplierId);
          this.status = this.purchaseOrder.status;
          if (this.status == "FINISHED" || this.status == "CANCEL") {
            this.btnDisabled = true;
          }
          this.issueDate = commonService.millisecondToDate(
            this.purchaseOrder.issueDateInMilliSeconds,
            "YYYY-MM-DD"
          );
          this.createdDate = commonService.formatDate(
            new Date(this.purchaseOrder.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.purchaseOrder.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          // deep copy
          this.oldpurchaseOrder = JSON.parse(JSON.stringify(res.data));
        })
        .catch(err => {
          console.log(err);
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        //convert to millisecond
        this.purchaseOrder.issueDateInMilliSeconds = commonService.convertToMilliseconds(
          this.issueDate
        );

        purchaseOrderService
          .savePurchaseOrder(this.purchaseOrder)
          .then(res => {
            if (res) {
              this.goBack();
            }
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },

    initPrice(factorUnitName, index) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.purchaseOrder.purchaseOrderItems[index].productUnits
      );
      this.purchaseOrder.purchaseOrderItems[index].unitCost =
        productUnit.unitCost;
      this.purchaseOrder.purchaseOrderItems[index].sellingPrice =
        productUnit.sellingPrice;
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.purchaseOrder.id) {
        this.purchaseOrder = new PurchaseOrder();
        this.addPurchaseOrderItem();
      } else {
        this.purchaseOrder = Object.assign({}, this.oldpurchaseOrder);
        this.getCurrencyBySupplierIdForUpdate(this.purchaseOrder.supplierId);
      }
    },

    getProductList() {
      var this_ = this;
      this_.showListLoading = true;
      this_.productList = [];

      if (this_.queryParams.supplierId) {
        return supplierProductService
          .getAllProductBySupplier(
            this_.queryParams,
            this_.pagination.page,
            this_.pagination.rowsPerPage
          )
          .then(res => {
            if (res.data) {
              this_.productList = res.data.productList;
              this_.totalRows = res.data.totalElements;
            }
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this_.showListLoading = false;
          });
      }
      return new Promise(function() {
        this_.showListLoading = false;
      });
    },

    showProducts() {
      // Clean query params
      this.queryParams.productCode = "";
      this.queryParams.productName = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";
      this.queryParams.currencyId = this.purchaseOrder.currencyId;
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },

    setProduct(code, index) {
      let product = commonService.search("code", code, this.productList);
      this.purchaseOrder.purchaseOrderItems[index].productCode = product.code;
      this.purchaseOrder.purchaseOrderItems[index].productName = product.name;
      this.purchaseOrder.purchaseOrderItems[index].factorUnitName = "";
      this.purchaseOrder.purchaseOrderItems[index].productUnits =
        product.productUnits;
      this.purchaseOrder.purchaseOrderItems[index].unitCost = 0;
      this.purchaseOrder.purchaseOrderItems[index].sellingPrice = 0;
      this.purchaseOrder.purchaseOrderItems[index].qty = 0;
    }
  }
};
</script>

